import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { KeyRound, Loader2, ArrowRight, ShieldCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function UmpireLogin() {
  const nav = useNavigate();
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (pin.trim().length < 4) { toast.error("Enter your PIN"); return; }
    setBusy(true);
    try {
      await api.post("/umpire/login", { pin: pin.trim() });
      toast.success("PIN accepted");
      nav("/umpire/score");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Invalid or expired PIN");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center cyber-grid px-4" style={{ background: "var(--bg)", color: "var(--text)" }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="w-full max-w-sm rounded-3xl glow-border p-8 grain" style={{ background: "var(--surface)" }} data-testid="umpire-login">
        <div className="w-14 h-14 rounded-2xl glass flex items-center justify-center mb-6 pulse-ring"><ShieldCheck className="w-7 h-7 text-primary-c" /></div>
        <span className="text-xs tracking-[0.25em] uppercase font-bold text-primary-c">Umpire access</span>
        <h1 className="font-display font-bold text-2xl mt-2">Enter court PIN</h1>
        <p className="text-sm mt-2" style={{ color: "var(--text-2)" }}>Enter the PIN your organizer gave you to open your match scorecard.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="relative">
            <KeyRound className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-primary-c" />
            <input data-testid="umpire-pin-input" value={pin} onChange={(e) => setPin(e.target.value.toUpperCase())} placeholder="6-char PIN" maxLength={12}
              className="w-full rounded-2xl bg-surface glow-border pl-12 pr-4 py-4 text-center text-2xl font-display font-black tracking-[0.3em] outline-none focus:ring-2 focus:ring-lime-400" style={{ color: "var(--text)" }} />
          </div>
          <button type="submit" data-testid="umpire-pin-submit" disabled={busy} className="btn-glow w-full rounded-2xl py-4 font-bold flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Open scorecard <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>
        <button data-testid="umpire-account-login" onClick={() => nav("/login")} className="mt-5 text-xs w-full text-center" style={{ color: "var(--text-2)" }}>
          Have an umpire account? <span className="text-primary-c font-bold">Sign in here</span>
        </button>
      </motion.div>
    </div>
  );
}
